<template>
	<pop-up-wrapper @close="this.$emit('close')">
		<div class="pop-up-qcm-soluce">
			<img
				class="close"
				@click="this.$emit('close')"
				src="/img/close.svg"
				alt=""
			/>

			<div class="btn-container">
				<button class="submit dark" @click="download">
					Télécharger
				</button>
			</div>
			<table v-if="!isLoading">
				<thead>
					<tr>
						<th>Questions</th>
						<th>Reponses</th>
					</tr>
				</thead>
				<tbody id="table">
					<tr
						v-for="question in questions.activities"
						:key="question.id"
					>
						<td v-html="question.description" v-mathjax></td>
						<td v-html="question.correction" v-mathjax></td>
					</tr>
				</tbody>
			</table>
			<Loader v-if="isLoading" />
		</div>
		<Loader v-if="isLoadingPdfGeneration" />

		<Teleport to="body">
			<PopUpShareResource
				v-if="isPopUpShareVisible"
				@close="isPopUpShareVisible = false"
				:id="id"
			/>
		</Teleport>
	</pop-up-wrapper>
</template>

<script>
import Loader from "../../Loader.vue";
import PopUpWrapper from "../PopUpWrapper.vue";
import PopUpShareResource from "../PopUpShareResource.vue";
import { generatedQuestionsPDF } from "../../../utils/utils.js";

export default {
	components: { PopUpWrapper, Loader, PopUpShareResource },
	props: {
		questions: {
			type: Object,
			required: false
		},
		heritedQuestions: {
			type: Array,
			required: false
		}
	},
	emits: ["close"],
	data() {
		return {
			isLoading: false,
			isLoadingPdfGeneration: false,
			isPopUpShareVisible: false
		};
	},
	methods: {
		async download() {
			this.isLoadingPdfGeneration = true;
			try {
				await generatedQuestionsPDF(
					this.questions.activities,
					true,
					this.questions.name
				);
			} catch {
				this.$store.state.toast = {
					text: "Erreur lors de l'impression de la correction",
					status: "error"
				};
			} finally {
				this.isLoadingPdfGeneration = false;
			}
		},
		async reRender() {
			if (window.MathJax.typesetPromise) {
				window.MathJax.typesetPromise();
			}
		},
		created(){
			this.$nextTick(() => {
				this.reRender();
			});		}
	}
};
</script>
